import React from "react";
// import { Link } from "react-router-dom";




export default class Subscription extends React.Component {

    plans = [
        {
            time: '12',
            orginal_price: '44990',
            offer_price: '15830',
            monthly_price: '1218',
            features: ['+ Get FREE Amazon Pay Gift Card worth ₹500', '+ FREE 1 Month extension', '+ 2 more offers'],
            // buttonText: 'Get Started',
        },
        {
            time: '6',
            orginal_price: '25090',
            offer_price: '12525',
            monthly_price: '1218',
            features: ['+ Additional Rs.1000 off applied', '+ 30 Days of membership pause', '+ 2 more offers'],
            // buttonText: 'Get Started',
        },
        {
            time: '3',
            orginal_price: '15590',
            offer_price: '10459',
            monthly_price: '1218',
            features: ['+ Additional Rs.1000 off applied', '+ 30 Days of membership pause', '+ 2 more offers'],
            // buttonText: 'Get Started',
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            'dishes' : [1, 2, 3],
        }
    }

    render(){
        return(
            <div>
                <div class="wrapper">
                   <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb1.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>Subscription</h2>
                            <a href="index.html">Home</a> - <a href="menu.html">Subscription</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">

                    <section class="product-container">
                        
                        {/* <!-- <div class="tomato"><img src="images/tomato.png" alt=""></div>
                        <div class="mashroom"><img src="images/mashroom.png" alt=""></div>
                        <div class="pie-larg"><img src="images/pea-larg.png" alt=""></div> --> */}
                        <div class="container">
                            <section class="our-client-container">
                            <div class="container"> 
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <h2>Healthy Meals Delivered Daily - Village Cafe Subscription Plans</h2>
                                        </div>
                                    </div> 
                                </div> {/* <!-- heading --> */}
                                <div class="our-client text-left">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <p style={{fontSize:18}}><span class="quort">“</span>Too busy to cook but still want <span style={{fontWeight:'700'}}>healthy South Indian food every day</span>? Try our <span style={{fontWeight:'700'}}>Food Subscription Plans : </span></p>
                                        </div> {/* <!-- client-content --> */} 
                                    </div>
                                </div>
                            </div>
                        </section>

                            
                    
                        <section class="event-container">
                            <div class="container">
                            <div class="event-detail-wrap event-detail-noimg">
                                <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <h3>Daily & Weekly Options : </h3>
                                    <p style={{fontSize:18}}>Flexible plans to suit your lifestyle.</p>
                                </div> {/* <!-- event-list --> */}
                            </div> {/* <!-- event-wrap --> */}

                            <div class="event-detail-wrap event-detail-noimg">
                                <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <h3>Balanced Meals : </h3>
                                    <p style={{fontSize:18}}><span style={{fontWeight:'700'}}>Calorie-conscious South Indian thalis, millet-based meals</span>, and seasonal specials.</p>
                                </div> {/* <!-- event-list --> */}
                            </div> {/* <!-- event-wrap --> */}

                            <div class="event-detail-wrap event-detail-noimg">
                                <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <h3>Grandma's Touch Every Day : </h3>
                                    <p style={{fontSize:18}}>Freshly cooked food delivered just like home.</p>
                                </div> {/* <!-- event-list --> */}
                            </div> {/* <!-- event-wrap --> */}

                            <div class="event-detail-wrap event-detail-noimg">
                                <div class="event-list wow fadeInDown text-center" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <h3>Affordable & Convenient : </h3>
                                    <p style={{fontSize:18}}>Tasty, healthy meals without worrying about daily cooking.</p>
                                </div> {/* <!-- event-list --> */}
                            </div> {/* <!-- event-wrap --> */}


                            {/* <section class="product-container"> */}
                                {/* <div class="container">                   */}
                                    {/* <div class="dishes-container"> */}
                                        {this.plans.map((plan, index) => (
                                            <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                                <div class="dishes-list" style={{'backgroundColor' : '#303638',borderRadius:'3%',padding:5}}>
                                                    {/* <h2 style={{'color' : '#FFFFFF', 'padding' : '20px'}}>{plan.name}</h2> */}
                                                    
                                                    
                                                    <div class='row' style={{display:'flex',alignItems:'center',justifyContent: 'space-between'}}>
                                                        <div class="col-lg-6">
                                                            <p style={{color:"#ffffff",fontSize:'40px',fontWeight:'700'}}>{plan.time}</p>
                                                            <p style={{color:"#ffffff",fontSize:'20px',fontWeight:'700'}}>MONTHS</p>
                                                        </div>
                                                        {/* <div class="col-lg-2">
                                                        </div> */}

                                                        <div class="col-lg-6">
                                                            <p style={{color:'white',textAlign:'left',textDecoration: 'line-through'}}>{plan.orginal_price}</p>
                                                            <p style={{color:'#3cc393',textAlign:'left',fontWeight:'700',fontSize:'25px',lineHeight:'50%'}}>₹{plan.offer_price}</p>
                                                            <p style={{color:'white',textAlign:'left'}}>{plan.monthly_price} per month*</p>
                                                        </div>
                                                    </div>

                                                    <hr style={{ borderColor: 'white', borderWidth: '1px', margin: '10px 0' }} />

                                                    {/* <div class="dishes-content text-left">
                                                        <p style={{'color' : '#FFFFFF', 'padding' : '10px'}}></p>
                                                    </div> */}
                                                    <ul className="mb-6 mt-6" style={{'padding' : '10px',height:180}}>
                                                        {plan.features.map((feature, i) => (
                                                            <li key={i} style={{'color' : '#FFFFFF'}} className="text-white-700 text-left">
                                                                ✅ {feature}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    {/* <a href="#/" class="btn-black" style={{'backgroundColor' : '#FFFFFF'}}>New</a> */}
                                                    <button style={{backgroundColor: 'white',color: 'red',padding: '8px 20px',border: 'none',borderRadius: '5px',cursor: 'pointer',fontSize: '15px',marginBottom:'3%'}}>BUY NOW</button>

                                                </div>
                                            </div>
                                        ))}
                                    {/* </div> */}
                                {/* </div> */}
                            {/* </section> */}

                        {/* <section>
                            <div class="container">
                                <div class="row" style={{marginTop:'0%',marginBottom:'5%'}}>
                                    <div class="col-md-3 col-sm-3 col-xs-12" style={{backgroundColor:'#303638',borderRadius:'3%',height:'50%',width:'32%',paddingTop:'2%',paddingBottom:'2%'}}>
                                        <div class='row' style={{display:'flex',alignItems:'center',justifyContent: 'space-between'}}>
                                            <div class="col-lg-4">
                                                <p style={{color:"#ffffff",fontSize:'40px',fontWeight:'700'}}>12</p>
                                                <p style={{color:"#ffffff",fontSize:'20px',fontWeight:'700'}}>MONTHS</p>
                                            </div>
                                            <div class="col-lg-3">
                                            </div>

                                            <div class="col-lg-5">
                                                <p style={{color:'white',textAlign:'left',textDecoration: 'line-through'}}>44990</p>
                                                <p style={{color:'#3cc393',textAlign:'left',fontWeight:'700',fontSize:'25px',lineHeight:'50%'}}>₹15830</p>
                                                <p style={{color:'white',textAlign:'left'}}>1218 per month*</p>
                                            </div>
                                        </div>
                                        <hr style={{ borderColor: 'white', borderWidth: '1px', margin: '10px 0' }} />
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left'}}>+ Get FREE Amazon Pay Gift Card worth ₹500</p>     
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left',lineHeight:'50%'}}>+ FREE 1 Month extension</p> 
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left'}}>+ 2 more offers</p>         
                                        <button style={{backgroundColor: 'white',color: 'red',padding: '10px 20px',border: 'none',borderRadius: '5px',cursor: 'pointer',fontSize: '16px',marginTop:'20%'}}>BUY NOW</button>
                                    </div>
                                    <div class="col-md-3 col-sm-3 col-xs-12" style={{backgroundColor:'#303638',borderRadius:'3%',height:'50%',width:'32%',paddingTop:'2%',paddingBottom:'2%',marginLeft:'10px',marginRight:'10px'}}>
                                        <div class='row' style={{display:'flex',alignItems:'center',justifyContent: 'space-between'}}>
                                            <div class="col-lg-4">
                                                <p style={{color:"#ffffff",fontSize:'40px',fontWeight:'700'}}>6</p>
                                                <p style={{color:"#ffffff",fontSize:'20px',fontWeight:'700'}}>MONTHS</p>
                                            </div>
                                            <div class="col-lg-3">
                                            </div>

                                            <div class="col-lg-5">
                                                <p style={{color:'white',textAlign:'left',textDecoration: 'line-through'}}>25090</p>
                                                <p style={{color:'#3cc393',textAlign:'left',fontWeight:'700',fontSize:'25px',lineHeight:'50%'}}>₹12525</p>
                                                <p style={{color:'white',textAlign:'left'}}>2088 per month*</p>
                                            </div>
                                        </div>
                                        <hr style={{ borderColor: 'white', borderWidth: '1px', margin: '10px 0' }} />
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left'}}>+ Additional Rs.1000 off applied</p>     
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left',lineHeight:'50%'}}>+ 30 Days of membership pause</p> 
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left'}}>+ 2 more offers</p>         
                                        <button style={{backgroundColor: 'white',color: 'red',padding: '10px 20px',border: 'none',borderRadius: '5px',cursor: 'pointer',fontSize: '16px',marginTop:'20%'}}>BUY NOW</button>
                                    </div>
                                    <div class="col-md-3 col-sm-3 col-xs-12" style={{backgroundColor:'#303638',borderRadius:'3%',height:'50%',width:'32%',paddingTop:'2%',paddingBottom:'2%'}}>
                                        <div class='row' style={{display:'flex',alignItems:'center',justifyContent: 'space-between'}}>
                                            <div class="col-lg-4">
                                                <p style={{color:"#ffffff",fontSize:'40px',fontWeight:'700'}}>3</p>
                                                <p style={{color:"#ffffff",fontSize:'20px',fontWeight:'700'}}>MONTHS</p>
                                            </div>
                                            <div class="col-lg-3">
                                            </div>

                                            <div class="col-lg-5">
                                                <p style={{color:'white',textAlign:'left',textDecoration: 'line-through'}}>15590</p>
                                                <p style={{color:'#3cc393',textAlign:'left',fontWeight:'700',fontSize:'25px',lineHeight:'50%'}}>₹10459</p>
                                                <p style={{color:'white',textAlign:'left'}}>3486 per month*</p>
                                            </div>
                                        </div>
                                        <hr style={{ borderColor: 'white', borderWidth: '1px', margin: '10px 0' }} />
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left'}}>+ Additional Rs.1000 off applied</p>     
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left',lineHeight:'50%'}}>+ 30 Days of membership pause</p> 
                                        <p style={{color:'white',fontSize:'14px',textAlign:'left'}}>+ 2 more offers</p>         
                                        <button style={{backgroundColor: 'white',color: 'red',padding: '10px 20px',border: 'none',borderRadius: '5px',cursor: 'pointer',fontSize: '16px',marginTop:'20%'}}>BUY NOW</button>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                         
                        </div>
                        <div style={{margin:5}}> 
                            <span style={{fontSize:20}}>Available across Hyderabad - delivered hot and fresh to your doorstep.</span>
                        </div>
                        
                        </section>
                            
                          
                     
                            
                        
                        </div>


                       
                        
                    </section>
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                </div>
            </div>
        )
    }
}